import callApi from 'helpers/callApi';

export const getContents = async (pageName) => {
  const contents = await callApi({ url: `/contents/pages/${pageName}` });
  const mappedContentList = {};
  contents.forEach((item) => {
    const { key, ...remainingContent } = item;
    mappedContentList[key] = remainingContent;
  });
  return mappedContentList;
};
export const getContentCount = () => callApi({ url: '/contents/counts' });
export const deleteContent = (id) => callApi({ url: `/contents/${id}`, method: 'delete' });

// export const deleteContent = (id) => deleteContentLoader.del(`/contents/${id}`);
export const getPageList = () => callApi({ url: '/contents/pages' });

export const postNewPageContent = (data) => callApi({ url: `/contents/${data._id ? data._id : ''}`, body: data });
export const getContentProvinces = () => callApi({ url: '/contents/configs/provinces' });
export const getContentDistricts = (province) => callApi({ url: `/contents/configs/provinces/${province}` });

export const saveContentDistricts = (id, data) => callApi({ url: `/contents/configs/provinces/${id}`, body: data });
export const saveContentProvince = (data) => callApi({ url: `/contents/configs/provinces`, body: data });

// export const saveContentDistricts = (id, data) => getContentDistrictsLoader.post(`/contents/configs/provinces/${id}`, { data });
// export const saveContentProvince = (data) => getContentDistrictsLoader.post(`/contents/configs/provinces`, { data });
